module.exports = __webpack_public_path__ + "images/stickers/taco-active.e027fa08f49b43a503a1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-active.png
// module id = vXsa
// module chunks = 2